<template>
<div class="chapter">
<div class="inner_page">
<p class="center4"><a id="page_iii">“O<span class="small">NCE UPON A</span> T<span class="small">IME</span>”</a></p><a id="page_iii">
<p class="center1">IS TIMELESS WITH THESE RETOLD TALES:</p>
<p class="center"><em>Beauty Sleep: A Retelling of “Sleeping Beauty”</em></p>
<p class="center1">By Cameron Dokey</p>
<p class="center"><em>Midnight Pearls: A Retelling of “The Little Mermaid”</em></p>
<p class="center1">By Debbie Viguié</p>
<p class="center"><em>Snow: A Retelling of “Snow White and the Seven Dwarfs”</em></p>
<p class="center1">By Tracy Lynn</p>
<p class="center"><em>Water Song:</em> A <em>Retelling of “The Frog Prince”</em></p>
<p class="center1">By Suzanne Weyn</p>
<p class="center"><em>Before Midnight:</em> A <em>Retelling of “Cinderella”</em></p>
<p class="center1">By Cameron Dokey</p>
<p class="center"><em>The Storyteller’s Daughter:</em> A <em>Retelling of<br/>“The Arabian Nights”</em></p>
<p class="center1">By Cameron Dokey</p>
<p class="center"><em>Golden: A Retelling of “Rapunzel”</em></p>
<p class="center1">By Cameron Dokey</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter02.vue?c63d3086